import React from 'react';
import {
  OfferCardStatusEnum,
  OfferTypeEnum,
  StepupOfferCardProps,
} from '@wwe-portal/ui/features/offer';
import { OfferData, OfferCardTypeEnum } from '@wwe-portal/entities/offer.type';
import { StepupOffer } from '@wwe-portal/entities/stepup.type';
import {
  parseRegionalOfferPrice,
  parseRegionalOfferStrikethroughPrice,
  offerToItemProps,
} from '@wwe-portal/web/utils/offer/mapper';

const getCombinationType = (type: string | undefined) => {
  if (
    type != null &&
    Object.values(OfferCardTypeEnum).includes(type as OfferCardTypeEnum)
  ) {
    return type as OfferCardTypeEnum;
  }
};

export const isFreeClaimOffer = (offerData: OfferData) => {
  return (
    offerData.OfferType === OfferTypeEnum.AlternativeCurrency &&
    !offerData.AlternativeCostAmount
  );
};

export const isAlternativeCurrencyOffer = (offerData: OfferData) => {
  return (
    offerData.OfferType === OfferTypeEnum.AlternativeCurrency &&
    offerData.AlternativeCostAmount != null &&
    offerData.AlternativeCostAmount > 0
  );
};

export const isStandardOffer = (offerData: OfferData) => {
  return offerData.OfferType === OfferTypeEnum.Standard;
};

export const parsePrice = (offerData: OfferData) => {
  if (isFreeClaimOffer(offerData)) return <>Claim</>;

  return <>{offerData.AlternativeCostAmount ?? offerData.Price?.USD}</>;
};

export const parserServerOfferData = (serverOffer: StepupOffer) => {
  const offer: OfferData =
    typeof serverOffer.offerData === 'string'
      ? JSON.parse(serverOffer.offerData)
      : serverOffer.offerData;

  const combinationType = getCombinationType(offer.CombinationType);
  if (combinationType == null) throw new Error('invalid combination type');
  const offerProps: { props: StepupOfferCardProps; origin: StepupOffer } = {
    props: {
      id: serverOffer.offerId,
      dynamicBackgroundImage: offer.OfferBackgroundImageResize,
      backgroundImage: offer?.OfferBackgroundImage,
      title: offer.StoreItemName,
      strikethroughPrice: parseRegionalOfferStrikethroughPrice(offer).price,
      maxQuantity: undefined,
      quantity: undefined,
      type: combinationType,
      items: offerToItemProps(offer),
      orderId: serverOffer.orderId,
      status: OfferCardStatusEnum.LOCKED,
      endDate: undefined,
      ...parseRegionalOfferPrice(offer),
    },
    origin: serverOffer,
  };
  return offerProps;
};

const getStatus = (index: number, claimedItems: number) => {
  if (index < claimedItems) return OfferCardStatusEnum.CLAIMED;
  if (index === claimedItems) return OfferCardStatusEnum.CLAIM;
  return OfferCardStatusEnum.LOCKED;
};

export const loadOfferStatuses = <T extends { props: StepupOfferCardProps }>({
  offers,
  claimedItems,
}: {
  offers: T[];
  claimedItems: number;
}) => {
  return offers.map((offer, index) => ({
    ...offer,
    props: {
      ...offer.props,
      status: getStatus(index, claimedItems),
    },
  }));
};
